import config from '@/configs'
import moment from "moment"
import { currency } from "@/commons/currency";

export function request_header(token) {
  return {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "accept": "application/json",
  };
}

export function request_payload(param) {
  let query = '';
  if(param && (param.pagination || param.qObject || param.filter || param.quickFilter)) {
    const page = param.pagination && param.pagination.page ? param.pagination.page : 1
    const rowsPerPage = param.pagination && param.pagination.itemsPerPage ? param.pagination.itemsPerPage : 1000000
    const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
    const descending = param.pagination ? param.pagination.sortDesc[0] : 1
    const qObject = param.qObject ? Buffer.from(JSON.stringify({ qObject: param.qObject })).toString("base64") : '';
    const filter = param.filter && param.filter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.filter })).toString("base64") : '';
    const quickFilter = param.quickFilter && param.quickFilter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString("base64") : '';
    query = `?filter=${filter}&qObject=${qObject}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}&q=${quickFilter}`;

    if('startTime' in param) {
      query += `&startTime=${param.startTime}`
    }
    if('endTime' in param) {
      query += `&endTime=${param.endTime}`
    }
    if('staffName' in param) {
      query += `&staffName=${param.staffName}`
    }
    if('method' in param) {
      query += `&method=${param.method}`
    }
    if('uid' in param) {
      query += `&uid=${param.uid}`
    }
  }
  else if(param && param.is_master) {
    const is_master = param.is_master || '';
    const fields = param.fields || [];
    query = `?is_master=${is_master}&fields=${fields.join(',')}`;
  }
  else if(param) {
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = `?${fields.join('&')}`;
  }

  if(param && 'bell' in param) {
    query += `&bell=${param.bell}`
  }
  return query;
}

export function request_list(endpoint, cb, $http, param, token) {
  const req = {
    headers: request_header(token)
  };
  
  const query = request_payload(param);

  $http.get(`${config.API}/admin/api/${endpoint}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
  });
}

export function export_list(endpoint, cb, $http, param, token, func) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  func = func ? func : 'export'
  const query = request_payload(param)

  $http.get(`${config.API}/admin/api/${endpoint}/${func}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function import_list(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token)
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  $http.post(`${config.API}/admin/api/${endpoint}/${func}/`, param, header).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function request_detail(endpoint, cb, $http, id, token, param) {
  const header = {
    headers: request_header(token)
  };
  let query = '';
  if(param) {
    if(param.pagination) {
      const page = param.pagination ? param.pagination.page : 1
      const rowsPerPage = param.pagination ? param.pagination.itemsPerPage : 1000000
      const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
      const descending = param.pagination ? param.pagination.sortDesc[0] : 1
      query = `?page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}`;
      delete param.pagination;
    }
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = query == '' ? `?${fields.join('&')}` : `${query}&${fields.join('&')}`;
  }
  $http.get(`${config.API}/admin/api/${endpoint}/${id}${query}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
  });
}

export function update_detail(endpoint, cb, $http, param, pId, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  let path = pId == 0 ? `${config.API}/admin/api/${endpoint}/` : `${config.API}/admin/api/${endpoint}/${pId}`;
  $http.post(path, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
      refreshResource();
    }
  });
}

export function remove_detail(endpoint, cb, $http, id, token) {
  const header = {
    headers: request_header(token)
  };
  $http.delete(`${config.API}/admin/api/${endpoint}/${id}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  });
}

export function create_detail(endpoint, cb, $http, param, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  delete req['ID'];
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  $http.put(`${config.API}/admin/api/${endpoint}/`, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
      refreshResource();
    }
  });
}

export function comment_type(value) {
  const cmtType = config.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.name : '';
}

export function comment_type_color(value) {
  const cmtType = config.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.color : '#e6c87f';
}

export function comment_avatar(value) {
  if (value !== null) {
    return '/static/avatar/oee.png';
  }
  return '/static/avatar/no_avatar.png';
}

export function comment_color(value) {
  if (value) {
    return '#ff0000';
  }
  return '#0000ff';
}

export function payment_type(value) {
  switch (value) {
    case 2:
    case 3:
      return "Đặt cọc";
    case 12:
      return "Hoàn tiền"
    default:
      return "Thanh toán";
  }
}

export function payment_type_color(value) {
  switch (value) {
    case 2:
      return "#e6c87f";
    case 3:
      return "#ffff00";
    case 12:
      return "#ff0000"
    default:
      return "#0000ff";
  }
}

export function complain_type(value) {
  switch (value) {
    case 1:
      return "Chờ xử lý";
    case 2:
      return "Đang xử lý";
    case 3:
      return "Đã xử lý"
    default:
      return "Đã hủy";
  }
}

export function complain_type_color(value) {
  switch (value) {
    case 1:
      return "#ff0000";
    case 2:
      return "#797960";
    case 3:
      return "#0000ff"
    default:
      return "#e6c87f";
  }
}

export function trade_type(value) {
  const cmtType = config.TRADE_TYPE.find(obj => obj.value === value);
  return cmtType ? cmtType.name : '';
}

export function print_transaction(weight, transactionCode, customerName, orderId, numberOfCode) {
  var mywindow = window.open("", "PRINT");

  mywindow.document.write("<html><head><title></title>");
  mywindow.document.write(
    "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
  );
  mywindow.document.write(
    ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
  );
  mywindow.document.write(
    ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
  );
  mywindow.document.write(
    "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
  );
  mywindow.document.write("<div class='layout wrap'>");
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${customerName}</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><hr class='v-divider theme--light'></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${orderId}</p></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Tổng kiện</p></div><div class='flex lg6'><p class='sub-title r-text'>${numberOfCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${weight} kg</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Mã vận đơn</p></div><div class='flex lg6'><p class='sub-title r-text'>${transactionCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
      new Date()
    ).format("DD-MM-YYYY")}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Lưu ý</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Qúy khách khi bóc hàng vui lòng giữ lại mã vận đơn Trung Quốc để sử dụng trong trường hợp Khiếu nại với nhà cung cấp</p></div>`
  );
  mywindow.document.write(`<hr class='v-divider theme--light'>`);
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>https://phanmemdathangoee.com</p></div>`
  );
  mywindow.document.write("</div>");
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  mywindow.close();
  return true;
}

export function print_export_receipt_order(item, packages, render = false, isChinhNgach = false) {
  // Template cho phiếu chính ngạch
  if (isChinhNgach) {
    const priceOfPack = item.PriceOfPack || 0;
    const numberOfPack = item.NumberOfPack || 0;
    const weight = item.Weight || 0;
    const vatRate = item.VatRate || 0;
    const exportRate = item.ExportRate || 0;
    const importRate = item.ImportRate || 0;
    const trusteeRate = item.TrusteeRate || 0;
    const feeShipVND = item.FeeShipVND || 0;
    const vnFeeShip = item.VNFeeShip || 0;
    const exchangeRate = item.ExchangeRate || 0;
    const feeShip = item.FeeShip || 0;
    const price = item.Price || 0;
    
    // Tính toán các giá trị
    const goodsValue = priceOfPack * numberOfPack;
    const transportCost = weight * price;
    const vatAmount = goodsValue * vatRate / 100;
    const exportFee = goodsValue * exportRate / 100;
    const importFee = goodsValue * importRate / 100;
    const trusteeFee = goodsValue * trusteeRate / 100;
    const totalAmount = goodsValue + transportCost + vatAmount + exportFee + importFee + trusteeFee + feeShipVND + vnFeeShip;
    
    const print_content = `<html>
    <head>
        <title>Phiếu xuất kho chính ngạch</title>
        <style>
            body { font-family: 'Times New Roman', Times, serif; font-size: 14px; margin: 20px; }
            .header { text-align: center; font-weight: bold; font-size: 18px; margin: 20px 0; }
            .sub-header { text-align: left; margin: 10px 0; }
            table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            th, td { border: 1px solid #000; padding: 8px; text-align: left; }
            th { background-color: #f0f0f0; font-weight: bold; text-align: center; }
            .text-right { text-align: right; }
            .text-center { text-align: center; }
            .total-row { font-weight: bold; background-color: #e0e0e0; }
            @media print { @page { size: auto; margin: 15mm; } }
        </style>
    </head>
    <body>
        <div class="header">PHIẾU XUẤT KHO CHÍNH NGẠCH</div>
        <div class="sub-header">
            <strong>TÊN KHÁCH HÀNG:</strong> ${item.Username || ''}
            <br/>
            <strong>TỶ GIÁ:</strong> ${currency(exchangeRate)}
        </div>
        <table>
            <thead>
                <tr>
                    <th style="width: 25%">NỘI DUNG</th>
                    <th style="width: 10%">THUẾ</th>
                    <th style="width: 10%">SỐ KIỆN</th>
                    <th style="width: 10%">SỐ KG</th>
                    <th style="width: 10%">SỐ M3</th>
                    <th style="width: 15%">ĐƠN GIÁ</th>
                    <th style="width: 20%">THÀNH TIỀN</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>GIÁ TRỊ LÔ HÀNG</td>
                    <td class="text-center"></td>
                    <td class="text-center">${numberOfPack}</td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-right">${currency(priceOfPack)} đ</td>
                    <td class="text-right">${currency(goodsValue)} đ</td>
                </tr>
                <tr>
                    <td>CƯỚC VẬN CHUYỂN TQ - VN</td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center">${weight}</td>
                    <td class="text-center"></td>
                    <td class="text-right">${currency(price)} đ</td>
                    <td class="text-right">${currency(transportCost)} đ</td>
                </tr>
                <tr>
                    <td>THUẾ VAT</td>
                    <td class="text-center">${vatRate}%</td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-right">${currency(vatAmount)} đ</td>
                </tr>
                <tr>
                    <td>THUẾ XUẤT KHẨU</td>
                    <td class="text-center">${exportRate}%</td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-right">${currency(exportFee)} đ</td>
                </tr>
                <tr>
                    <td>THUẾ NHẬP KHẨU</td>
                    <td class="text-center">${importRate}%</td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-right">${currency(importFee)} đ</td>
                </tr>
                <tr>
                    <td>PHÍ ỦY THÁC</td>
                    <td class="text-center">${trusteeRate}%</td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-right">${currency(trusteeFee)} đ</td>
                </tr>
                <tr>
                    <td>PHÍ SHIP NỘI ĐỊA TQ</td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-right">${feeShip}¥</td>
                    <td class="text-right">${currency(feeShipVND)} đ</td>
                </tr>
                <tr>
                    <td>PHÍ SHIP NỘI ĐỊA VN</td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-right">${currency(vnFeeShip)} đ</td>
                    <td class="text-right">${currency(vnFeeShip)} đ</td>
                </tr>
                <tr class="total-row">
                    <td colspan="6" class="text-center">TỔNG</td>
                    <td class="text-right">${currency(totalAmount)} đ</td>
                </tr>
            </tbody>
        </table>
        <div style="margin-top: 40px;">
            <i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i>
        </div>
    </body>
    </html>`;
    
    if(render) {
      return print_content;
    }
    var mywindow = window.open("", "PRINT");
    mywindow.document.write(print_content);
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    return true;
  }
  
  // Template cho phiếu thường
  let html_packages = ''
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];

    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>${p.OrderTransactionCode}</td>
                        <td class='body-text m-text'>${p.OrderID}</td>
                        <td class='body-text m-text'></td>
                        ${i == 0 ? ("<td class='body-text m-text'rowspan='"+packages.length+"'>"+(item.FeeType == 1 ? item.Weight : item.Volume)+"</td>") : ""}
                        ${i == 0 ? ("<td class='body-text m-text'rowspan='"+packages.length+"'>"+(item.FeeType == 1 ? 'KG' : 'M3')+"</td>") : ""}
                        ${i == 0 ? ("<td class='body-text m-text'rowspan='"+packages.length+"'>"+currency(item.FeeShipVND)+"</td>") : ""}
                        ${i == 0 ? ("<td class='body-text m-text'rowspan='"+packages.length+"'>"+currency(item.VNFeeShip)+"</td>") : ""}
                        ${i == 0 ? ("<td class='body-text m-text'rowspan='"+packages.length+"'>"+currency(item.Amount)+"</td>") : ""}
                        <td class='body-text m-text'></td>
                      </tr>`
  }

  const print_content = `<html>
  <head>
      <title></title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:297mm;font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text'><image src='/static/v-logo.png'/></td>
                <td class='no-boder sub-title m-text'>TNMLOGISTICS.COM<br/>PHIẾU XUẤT KHO</td>
              </tr>	
              <tr>
                <td class='no-boder sub-title m-text'>0977.343.715 - 094.777.3826</td>
                <td class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              <tr>        
                <td class='no-boder body-text' colspan='4'>Số phiếu: ....</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Người nhận hàng: ${item.Username}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text'>Đơn giá: ${currency(item.Price)} - Tỷ giá: ${currency(item.ExchangeRate)}</td>
              </tr>
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text'>STT</td>            
                  <td class='sub-title m-text'>Mã vận đơn</td>            
                  <td class='sub-title m-text'>Mã đơn hàng</td>
                  <td class='sub-title m-text'>ĐVT</td>            
                  <td class='sub-title m-text'>Trọng lượng/Khối</td>            
                  <td class='sub-title m-text'>Quy cách</td>
                  <td class='sub-title m-text'>Phí ship TQ</td>
                  <td class='sub-title m-text'>Phí ship VN</td>
                  <td class='sub-title m-text'>Thành tiền</td>
                  <td class='sub-title m-text'>Ghi chú</td>
              </tr>
              ${html_packages}
              <tr>
                <td class='sub-title m-text' colspan='4'>Tổng số</td>
                <td class='sub-title m-text'>${item.FeeType == 1 ? item.Weight : item.Volume}</td>
                <td class='sub-title r-text'></td>
                <td class='sub-title m-text'>${currency(item.FeeShipVND)}</td>
                <td class='sub-title m-text'>${currency(item.VNFeeShip)}</td>
                <td class='sub-title m-text'>${currency(item.Amount)}</td>
                <td class='sub-title m-text'></td>
              </tr> 
              <tr>
                  <td class='no-boder body-text' colspan='10'><i>Quý khách vui lòng kiểm tra lại mã hàng, số lượng, khối lượng khi nhận hàng!</i></td>
              </tr> 
              <tr>
                  <td class='no-boder body-text' colspan='10'>Chứng từ, giấy tờ kèm theo:</td>
              </tr> 
              <tr>
                  <td class='no-boder body-text r-text' colspan='9'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr> 
              <tr>
                  <td class='no-boder sub-title m-text' colspan='4'>Người giao<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='3'>Người nhận<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='3'>Người lập phiếu<br/><i>(Ký, ghi rõ họ tên)</i></td>
              </tr> 
              </table>
            </div>
        </body>
  </html>`;
  if(render) {
    return print_content;
  }
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(print_content);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  // mywindow.close();
  return true;
}